module.exports = {
      id: "summary-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "svg-sprite.svg#summary",
      toString: function () {
        return this.url;
      }
    }